import { z } from 'my-zod'
import { salesQuoteHeadersModel } from './sales-quote-headers-model'

export const updateSalesQuoteHeaderSystemRequest = salesQuoteHeadersModel.pick({
  id: true,
  type: true,
  ownerId: true,
  outfitterId: true,
  quoteDate: true,
  expirationDate: true,
  forecastedSignDate: true,
  implementationFee: true,
  discounts: true,
  addons: true,
  signedDate: true,
  notes: true
})

export type updateSalesQuoteHeaderSystemRequest = z.infer<typeof updateSalesQuoteHeaderSystemRequest>
